import React, { Component } from "react";
import { applyRouterMiddleware, Router, Route, IndexRoute } from "react-router";
import { useScroll } from "react-router-scroll";

// Include Google Analytics
import ReactGA from "react-ga";

if(process.env.REACT_APP_ENV === "production") {
  ReactGA.initialize("UA-85372747-1");
}

import "./App.css";

// import components
import AppReduxConnection from "../AppReduxConnection";
import Home from "../Home";
import About from "../About";
import Settings from "../Settings";
import Contact from "../Contact";
import Error from "../Error";

import clothingBrands from "../../data/clothing-brands";
import carSeatBrands from "../../data/car-seat-brands";

import BrandPage from "../Brands/BrandPage";

import { Provider } from "react-redux";
import store, { history } from "../../store";

class App extends Component {
  constructor(props) {
    super(props);
    this.pageChangeHandler = this.pageChangeHandler.bind(this);
  }

  pageChangeHandler() {
    ReactGA.pageview(window.location.pathname);
  }

  render() {
    return (
      <Provider store={store}>
        <Router onUpdate={this.pageChangeHandler}
          history={history}
          render={applyRouterMiddleware(useScroll())} >
          <Route path="/" component={AppReduxConnection}>
            <IndexRoute component={Home}/>
            <Route path="about" component={About} />
            <Route path="settings" component={Settings} />
            <Route path="contact" component={Contact} />

            <Route path="clothes">
              { clothingBrands.map(brand => <Route path={brand.key} component={() => <BrandPage brand={brand} type="Clothing" gender={store.gender}/> } key={brand.key} />) }
            </Route>

            <Route path="car-seats">
              { carSeatBrands.map(brand => <Route path={brand.key} component={() => <BrandPage brand={brand} type="Car Seat" /> } key={brand.key} />) }
            </Route>
            <Route path="*" component={Error} />
          </Route>
        </Router>
      </Provider>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App/App.js
 **/